import { useState } from 'react';
import useScrollFade from '../../../hooks/useScrollFade';

const testimonials = [
  {
    name: 'Dani Smith',
    role: 'Garmin',
    text: '"Exceptional client service and work. Top Shelf\'s thought leadership, value creation and innovation raise industry standards."',
  },
  {
    name: 'Jeff Bishop',
    role: 'Alexander Open Systems',
    text: '"Top Shelf was able to adapt to the environment, accomplish the requirements, and surpass expectations."',
  },
  {
    name: 'John Guzman',
    role: 'World Wide Technology',
    text: '"...rockstar on a very complex project that involved modernizing an application"',
  },
  {
    name: 'Ann Marie Dunlap',
    role: 'D. Thomas & Associates',
    text: '"You were key in making our journey a success story."',
  },
];

const TestimonialsSection = () => {
  const header = useScrollFade();
  const carousel = useScrollFade({ delay: 80 });

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          ref={header.ref}
          className={`text-center mb-16 ${header.fadeClass}`}
        >
          <h3 className="text-sm font-bold uppercase tracking-wider mb-3" style={{ color: '#b8860b' }}>
            Client Testimonials
          </h3>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="h-px w-16 bg-gray-200" />
            <div className="h-0.5 w-10 rounded-full bg-yellow-600" />
            <div className="h-px w-16 bg-gray-200" />
          </div>
        </div>

        <div
          ref={carousel.ref}
          className={`relative max-w-3xl mx-auto ${carousel.fadeClass}`}
        >
          <div className="bg-white rounded-2xl p-10 md:p-14 border border-gray-100 shadow-lg text-center">
            <i className="fas fa-quote-left text-4xl text-yellow-200 mb-6 block"></i>
            <p className="text-gray-700 text-lg leading-relaxed italic mb-8">
              {testimonials[currentIndex].text}
            </p>
            <div className="border-t border-gray-100 pt-6">
              <h4 className="text-xl font-bold text-gray-900 mb-1">
                {testimonials[currentIndex].name}
              </h4>
              <p className="text-sm font-medium uppercase tracking-wide" style={{ color: '#b8860b' }}>
                {testimonials[currentIndex].role}
              </p>
            </div>
          </div>

          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-16 w-12 h-12 flex items-center justify-center bg-white hover:bg-yellow-50 border border-gray-200 hover:border-yellow-400 rounded-full shadow-lg transition-all duration-300 cursor-pointer"
          >
            <i className="fas fa-chevron-left text-gray-600"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-16 w-12 h-12 flex items-center justify-center bg-white hover:bg-yellow-50 border border-gray-200 hover:border-yellow-400 rounded-full shadow-lg transition-all duration-300 cursor-pointer"
          >
            <i className="fas fa-chevron-right text-gray-600"></i>
          </button>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex
                    ? 'w-8 bg-yellow-600'
                    : 'w-2 bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
